export const editorColors = {
  global: {
    background1: '#f4f4f4',
    background2: '#fdfdfd',
    background3: '#ffffff',
    backgroundHover: '#f4f4f4',
    text: '#181818',
    border: '#d2d2d2',
    focus: 'hsl(252 95% 85% / 80%)',
    placeholder: '#a3a3a3',
  },
  primary: {
    background1: '#D72489',
    background2: 'hsl(250 95% 92%)',
    background3: 'hsl(250 100% 97%)',
    backgroundHover: 'hsl(263 69% 42%)',
    text: '#fffff',
  },
  component: {
    background1: '#D72489',
    background2: '#D72489',
    background3: '#D72489',
    backgroundHover: '#D72489',
    text: '#fffff',
  },
  selector: {
    background1: 'hsl(336 69% 30%)',
    background2: 'hsl(336 84% 90%)',
    background3: 'hsl(336 84% 97%)',
    backgroundHover: 'hsl(336 84% 80%)',
    text: '#fffff',
  },
  symbol: {
    background1: 'hsl(258 90% 66%)',
    background2: 'hsl(250 95% 92%)',
    background3: 'hsl(250 100% 97%)',
    backgroundHover: 'hsl(263 69% 42%)',
    text: '#fffff',
  },
};
